<div class="row">
    <div class="col-md-8">
        <h5 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h5>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <h5 class="card-title font-weight-bold font-size-lg mb-4">Personal Info</h5>
            <form [formGroup]="employee_form">

                <div class="row">

                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="empid">Agency ID *</label>
                            <input id="empid" class="form-control" formControlName="empid" placeholder="Agency ID" type="text" [ngClass]="{'is-invalid': submitted && f.empid.errors}">
                            <div *ngFor="let validation of validation_messages.empid">
                                <div class="error-message" *ngIf="f.empid.hasError(validation.type) && ((f.empid.dirty  || f.empid.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="form-group"><label for="fname">Company Name *
                            </label><input id="fname" class="form-control" formControlName="fname" placeholder="Company Name" type="text" [ngClass]="{'is-invalid': submitted && f.fname.errors}">
                            <div *ngFor="let validation of validation_messages.fname">
                                <div class="error-message" *ngIf="f.fname.hasError(validation.type) && ((f.fname.dirty || f.fname.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class=" form-group"><label for="email">Company Email *
                            </label><input id="email" class="form-control" formControlName="email" placeholder="Company Email" type="text" [ngClass]="{'is-invalid': submitted && f.email.errors}">
                            <div *ngFor="let validation of validation_messages.email">
                                <div class="error-message" *ngIf="f.email.hasError(validation.type) && ((f.email.dirty || f.email.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="mobileNumber">Phone No *</label>
                            <input id="mobileNumber" class="form-control" formControlName="mobileNumber" placeholder="Phone No" type="text" [ngClass]="{'is-invalid': submitted && f.mobileNumber.errors}">
                            <div *ngFor="let validation of validation_messages.mobileNumber">
                                <div class="error-message" *ngIf="f.mobileNumber.hasError(validation.type) &&  ((f.mobileNumber.dirty ||  f.mobileNumber.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>               

                <div class="row">                   

                    <div class="col-md-9 col-sm-6">
                        <div class="form-group">
                            <label for="stations">Stations *</label>
                            <ng-select id="stations" [multiple]="true" required formControlName="stations" [(ngModel)]="selectedStations" [ngClass]="{'is-invalid': submitted && f.stations.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <ng-option *ngFor="let station of allStations" [value]="station.id">
                                    {{station.stationid}} - {{station.airport_name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.stations">
                                <div class="error-message" *ngIf="f.stations.hasError(validation.type) && ((f.stations.dirty || f.stations.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6" *ngIf="isEditMode">
                        <div class="position-relative form-group">
                            <label for="status">Status *</label>
                            <ng-select id="status" formControlName="status" [(ngModel)]="selectedStatus" placeholder="Select status" [ngClass]="{'is-invalid': submitted && f.status.errors}">
                                <ng-option *ngFor="let s of status" [value]="s">{{s}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.status">
                                <div class="error-message" *ngIf="f.status.hasError(validation.type) && ((f.status.dirty || f.status.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>

                <div class="row">
                    <div class="col-md-12 py-3">
                        <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                        <button id="saveTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddOutsourcedEmployee(employee_form.value)" *ngIf="!isEditMode">Add Outsourced Agency</button>
                        <button id="updateTeamMemberBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateOutsourcedEmployee(employee_form.value)" *ngIf="isEditMode">Update Outsourced Agency</button>
                        <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>